module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cellpadding column-id-head table-head-ceil"
  }, [_c('articleId')], 1), _vm._v(" "), _c('th', {
    staticClass: "articles-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_c('searchInArticles')], 1), _vm._v(" "), _c('th', {
    staticClass: "column-lng-head table-head-hover table-head-ceil",
    class: {
      'left-active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getLanguagesForSelect)
    },
    on: {
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getLanguagesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('languageArticles')], 1), _vm._v(" "), _c('th', [_c('typeArticles')], 1), _vm._v(" "), _c('th', [_c('topicsArticle')], 1), _vm._v(" "), _c('th', [_c('categoryArticles')], 1), _vm._v(" "), _c('th', [_c('accessArticle')], 1), _vm._v(" "), _c('th', [_c('companySpecificArticles')], 1), _vm._v(" "), _c('th', [_c('lastEditedArticles')], 1), _vm._v(" "), _c('th', [_c('uploaderEditorArticles')], 1), _vm._v(" "), _c('th', [_c('statusArticles')], 1), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('actionsArticles')], 1)])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "cellpadding"
  }, [_c('button', {
    staticClass: "table-crud-btn icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editArticle(_vm.article.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "table-tooltip-edit"
  }, [_vm._v("Edit")])], 1)]), _vm._v(" "), _c('td', {
    staticClass: "cellpadding"
  }, [_c('button', {
    staticClass: "table-crud-btn icon-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.initAction('removeArticle', {
          articleId: _vm.article.id,
          i: _vm.i
        })
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articles-list"
  }, [_c('div', {
    staticClass: "articles-list-heading"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7674af82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newCmsStyle/page/ArticlesList.vue
// module id = 962
// module chunks = 1